import { useSelector } from 'react-redux';
import * as dealScreenErrorSelectors from '@makemydeal/dr-dash-store/selectors/dealScreenErrorSelectors';
import type { EntityKey } from '@makemydeal/dr-dash-store/selectors/dealScreenErrorSelectors';
import { StatusIndicator } from '@interstate/components/StatusIndicator';

interface EntityErrorBadgeProps {
    entityName: EntityKey;
    showErrorCount?: boolean;
    xOffset?: string;
    yOffset?: string;
    /** Overrides the entity-wide count, for entities that hold errors for several rows. */
    hasError?: boolean;
}

/**
 * Memoized component that displays error count badge for a specific entity.
 */
const EntityErrorBadge = ({ entityName, showErrorCount = true, xOffset, yOffset, hasError }: EntityErrorBadgeProps) => {
    const dealScreenEntitiesErrorCounts = useSelector(dealScreenErrorSelectors.getEntityAggregatedErrors);
    const errorCount = dealScreenEntitiesErrorCounts[entityName];

    return hasError ?? errorCount > 0 ? (
        <StatusIndicator
            data-testid={`error-badge-${entityName}`}
            indicatorContent={errorCount}
            variant={showErrorCount ? 'standard' : 'dot'}
            {...(xOffset && { xOffset })}
            {...(yOffset && { yOffset })}
        >
            {showErrorCount && <div style={{ height: '1.6rem' }} />}
        </StatusIndicator>
    ) : null;
};

export default EntityErrorBadge;
